import { FlowComponent } from '../../../flow.min.js';
import styles from './styles.js';

const template = FlowComponent.html`
    <div class="flex items-center ${'positionClass'}">
        <input
            type="checkbox"
            id="${'id'}"
            name="${'name'}"
            ?disabled="${'disabled'}"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
        <label for="${'name'}" class="block text-sm text-gray-900 cursor-pointer ${'labelClass'}">
            ${'label'}
            <slot></slot>
        </label>
    </div>
`;

export class FlowCheckbox extends FlowComponent {
    static formAssociated = true;
    #internals;

    static get observedAttributes() {
        return ['checked', 'label', 'text-position', 'name', 'id', 'disabled'];
    }

    constructor() {
        super();
        this.#internals = this.attachInternals();
    }

    static get styles() { return styles; }
    static get template() { return template; }

    get checked() {
        return this.root.querySelector('input')?.checked || false;
    }

    set checked(val) {
        const input = this.root.querySelector('input');
        if (input) {
            const isChecked = !!val;
            input.checked = isChecked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
            this.setAttribute('checked', isChecked ? 'true' : 'false');
        }
    }

    get disabled() {
        return this.hasAttribute('disabled');
    }

    set disabled(val) {
        if (val) {
            this.setAttribute('disabled', '');
        } else {
            this.removeAttribute('disabled');
        }
    }

    onMount() {
        super.onMount();
        this.#updateLayout();
        
        const input = this.root.querySelector('input');

        input.onchange = () => {
            const isChecked = input.checked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
            this.setAttribute('checked', isChecked ? 'true' : 'false');
            
            this.dispatchEvent(new CustomEvent('change', {
                detail: { checked: isChecked },
                bubbles: true,
                composed: true
            }));
        };

        // Sincronizar estado inicial
        if (this.hasAttribute('checked')) {
            const attrVal = this.getAttribute('checked');
            const isChecked = attrVal === 'true' || attrVal === '';
            input.checked = isChecked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
        }
    }

    onAttributeChanged(name, oldValue, newValue) {
        super.onAttributeChanged(name, oldValue, newValue);
        if (name === 'text-position' && oldValue !== newValue) {
            this.#updateLayout();
        }
        if (name === 'checked' && oldValue !== newValue) {
            const input = this.root.querySelector('input');
            if (input) input.checked = newValue === 'true';
        }
    }

    #updateLayout() {
        const pos = this.getAttribute('text-position') || 'left';
        if (pos === 'left') {
            this.setAttribute('positionClass', 'flex-row-reverse justify-end');
            this.setAttribute('labelClass', 'mr-2');
        } else {
            this.setAttribute('positionClass', 'flex-row');
            this.setAttribute('labelClass', 'ml-2');
        }
    }
}

customElements.define('flow-checkbox', FlowCheckbox);
